
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Проект Gemini',
	'appExit': 'Перейти на страницу с приветствием',


	'widgetsListLabel': 'Список виджетов. Выберите виджет и нажмите клавишу ввода (Enter), чтобы добавить элемент.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Современный',
	'dirty': 'Не современный',
	'conflict': 'Конфликт при сохранении представления',
	'error': 'Проблема при сохранении представления',
	'failure': 'Не удается соединиться с сервером',
	'saveFailed': 'Не удается сохранить представление',

	'wa_insync': 'Сохранено',
	'wa_conflict': 'Конфликт при сохранении представления',
	'wa_error': 'Не удается сохранить представление',
	'wa_failure': 'Не удается соединиться с сервером',

	// Menu Labels
	'changeDisplay': 'Изменить представление',
	'changeToColumnChart': 'Перейти к вертикальной столбчатой диаграмме',
	'changeToBubbleChart': 'Перейти к пузырьковой диаграмме',
	'toggleMoveHandles': 'Переключить хэндлы перемещения',
	'undo': 'Откат',
	'redo': 'Повтор',
	'mode': 'Изменить режим',

	'untitled': 'Без названия',
	'remove': 'Удалить',
	'editTitle': 'Изменить заголовок',
	'edit': 'Изменить',
	'done': 'Готово',

	// Data tray
	'dataTrayHandleOpenLabel': 'Открыть панель данных',
	'dataTrayHandleCloseLabel': 'Закрыть панель данных',

	// Dialogs
	'dlg_loading': 'Загрузка...',
	'dlg_ok': 'ОК',
	'dlg_create': 'Создать',
	'dlg_cancel': 'Отмена',
	'dlg_close': 'Закрыть',
	'dlg_update': 'Обновить',
	'dlg_renameBoardTitle': 'Переименовать этот объект',
	'dlg_renameDatasetTitle': 'Переименовать этот набора данных',
	'dlg_renameSceneTitle': 'Переименовать эту сцену',
	'dlg_NameLabel': 'Имя:',
	'dlg_NewNameLabel': 'Новое имя:',
	'dlg_DefaultNameWithDataSet': 'Представление %{name}',
	'dlg_ShareTitle': 'Совместно использовать содержимое',
	'dlg_UnshareTitle': 'Аннулировать совместное использование содержимого',
	'dlg_ShareUser': 'ID пользователя:',
	'dlg_NewColumnLabel': 'Новое имя вычисления',

	'dlg_new': 'Создать...',
	'dlg_open': 'Открыть...',
	'dlg_makeACopy': 'Создать копию',
	'dlg_rename': 'Переименовать...',
	'dlg_moreToCome': 'Дополнительные действия...',

	'dlg_use': 'Использовать',

	'dlg_RelinkDatasetTitle': 'Заменить набор данных \'%{datasetName}\' на ...',

	'open_error': 'Произошла ошибка при открытии представления.',

	// Delete Board
	'del_dialogTitle': 'Подтвердить удаление',
	'del_itemMsg': 'Вы уверены, что хотите удалить \'%{name}\'?',
	'del_itemsMsg': 'Вы уверены, что хотите удалить %{count} элементов?',
	'del_deleteErr': 'Невозможно удалить \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'по восходящей',
	'dlg_descending': 'по нисходящей',
	'dlg_custom': 'настраиваемые',
	'dlg_none': 'нет',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Поиск',

	'searchHint': 'Поиск во всех ваших данных',
	'clearSearchResult': 'Очистить результаты поиска',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Круг',
	'shapesHexagon': 'Шестиугольник',
	'shapesLine': 'Линия',
	'shapesOctagon': 'Восьмиугольник',
	'shapesPentagon': 'Пятиугольник',
	'shapesSquare': 'Квадрат',
	'shapesTriangle': 'Треугольник',
	'shapesDiamond': 'Ромб',
	'shapesTitle': 'Свойства фигуры', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Квадрат с закругленными углами',
	'shapesStar': 'Звезда',
	'shapesChevron': 'Двойная угловая скобка',
	'shapesBadge_ribbon': 'Лента бейджа',
	'shapesBadge': 'Бейдж',
	'shapesHeart': 'Сердце',
	'shapesExclamation': 'Восклицательный знак',
	'shapesTrendingup': 'Тенденция к повышению',
	'shapesTrendingdown': 'Тенденция к снижению',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Сотрудники',
	'shapesFemale': 'Женский',
	'shapesHappyface': 'Счастливое лицо',
	'shapesMale': 'Мужской',
	'shapesMan': 'Мужчина',
	'shapesNeutralface': 'Нейтральное лицо',
	'shapesSadface': 'Печальное лицо',
	'shapesShakehands': 'Рукопожатие',
	'shapesThumbsdown': 'Большие пальцы вниз',
	'shapesThumbsup': 'Большие пальцы вверх',
	'shapesWoman': 'Женщина',

	// Weather and places
	'shapesPlacesWeatherCat': 'Места и погода',
	'shapesCity': 'Город',
	'shapesCloud': 'Облако',
	'shapesEducation': 'Образование',
	'shapesGovernment': 'Правительство',
	'shapesHalfcloud': 'Половина облака',
	'shapesHouse': 'Дом',
	'shapesMoon': 'Луна',
	'shapesRain': 'Дождь',
	'shapesSunny': 'Солнечно',

	//Vehicles
	'shapesVehiclesCat': 'Транспортные средства',
	'shapesAirplane': 'Самолет',
	'shapesCar': 'Автомобиль',
	'shapesShip': 'Корабль',
	'shapesShoppingcart': 'Корзина для покупок',
	'shapesTrain': 'Поезд',
	'shapesTruck': 'Грузовой автомобиль',

	//Objects
	'shapesObjectsCat': 'Объекты',
	'shapesBook': 'Книга',
	'shapesBriefcase': 'Портфель',
	'shapesCalendar': 'Календарь',
	'shapesCheck': 'Проверьте',
	'shapesClock': 'Часы',
	'shapesDesktop': 'Рабочий стол',
	'shapesDocument': 'Документ',

	'shapesFood': 'Еда',
	'shapesGear': 'Оборудование',
	'shapesHealth': 'Здоровье',

	'shapesIdea': 'Идея',
	'shapesMobile': 'Мобильный',
	'shapesMoney_bill': 'Деньги - Счет',
	'shapesMoney_coin': 'Деньги - Монета',
	'shapesPiggybank': 'Свинья-копилка',
	'shapesStackofpaper': 'Куча бумаг',
	'shapesStickynote1': 'Наклейка 1',
	'shapesStickynote2': 'Наклейка 2',
	'shapesTarget': 'Целевой объект',
	'shapesTool': 'Инструмент',

	'shapesUmbrella': 'Зонтик',

	'shapesBrain': 'Мозг',
	'shapesSkull': 'Череп',
	'shapesEye': 'Глаз',

	// Arrows shapes
	'shapesArrowsCat': 'Стрелки',
	'shapesRightArrow': 'Стрелка вправо',
	'shapesLeftArrow': 'Стрелка влево',
	'shapesDoubleArrow': 'Двойная стрелка',
	'shapesCurvedArrow': 'Искривленная стрелка',

	// Callouts shapes
	'shapesCalloutsCat': 'Выноски',
	'shapesRectCallout': 'Выноска',

	// Images
	'imagesCat': 'Изображения',
	'imageWidgetTitle': 'Виджет \'Изображение\'',
	'imgUrl': 'URL изображения',
	'noImgSelected': 'Не выбраны изображения',
	'enterImgUrl': 'Введите здесь URL изображения',
	'imgPasteLink': 'Вставьте URL и нажмите Enter, чтобы его сохранить.',
	'imgResizeToFit': 'Измените размер, чтобы изображение уместилось по размеру',
	'imgHeight': 'Высота:',
	'imgWidth': 'Ширина:',
	'imgTransparency': 'Прозрачность:',
	'imgMissingUrl': 'Отсутствует URL изображения.',
	'imgUrlValidationError': 'Недопустимый URL изображения.',
	'imgUrlInvalidDomainError': 'Этот URL изображения указывает на домен, не одобренный администратором. Домены, одобренные вашим администратором: "%{domains}".',

	// line shape
	'propStrokeWidth': 'Толщина линии',
	'propStrokeDashArray': 'Стиль линии',
	'propStrokeSolidline': 'Сплошная линия',
	'propStrokeLineCap': 'Ограничение линии',
	'propStrokeLineCapButt': 'Торец',
	'propStrokeLineCapRound': 'Округление',
	'propStrokeLineCapSquare': 'Квадрат',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Воспроизвести',
	'dataPlayerValueListLabel': 'Значения плеера данных',
	// Text Widget
	'textWidgetTitle': 'Виджет \'Текст\'',
	'textStyle': 'Стили',
	'textStyleDescription': 'Предварительно сформатированные стили текста',
	'textTitleStyle': 'Заголовок',
	'textTitleSmallStyle': 'Маленький заголовок',
	'textSubtitleStyle': 'Подзаголовок',
	'textBodyStyle': 'Текст',
	'textBodySmallStyle': 'Малая основная часть',
	'textCaptionStyle': 'Заголовок',
	'textQuoteStyle': 'Квота',
	'textQuoteSmallStyle': 'Малая квота',
	'textResponsiveStyle': 'Автоматическое изменение размера',
	'textAutoFontSize': 'Автоматически',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'С засечками',
	'textFontFamilySubClassThin': 'Тонкий',
	'textFontFamilySubClassThinItalic': 'Тонкий курсив',
	'textFontFamilySubClassExtraLight': 'Сверхсветлый',
	'textFontFamilySubClassExtraLightItalic': 'Сверхсветлый курсив',
	'textFontFamilySubClassLight': 'Светлый',
	'textFontFamilySubClassLightItalic': 'Светлый курсив',
	'textFontFamilySubClassRegular': 'Нормальный',
	'textFontFamilySubClassRegularItalic': 'Нормальный курсив',
	'textFontFamilySubClassItalic': 'Курсив',
	'textFontFamilySubClassMedium': 'Средний',
	'textFontFamilySubClassMediumItalic': 'Средний курсив',
	'textFontFamilySubClassHeavy': 'Плотный',
	'textFontFamilySubClassHeavyItalic': 'Плотный курсив',
	'textFontFamilySubClassDemiBold': 'Полужирный',
	'textFontFamilySubClassDemiBoldItalic': 'Полужирный курсив',
	'textFontFamilySubClassBold': 'Полужирный',
	'textFontFamilySubClassBoldItalic': 'Жирный курсив',
	'textFontFamilySubClassExtraBold': 'Сверхжирный',
	'textFontFamilySubClassExtraBoldItalic': 'Сверхжирный курсив',
	'textFontFamilySubClassBlack': 'Черный',
	'textFontFamilySubClassBlackItalic': 'Черный курсив',
	'textFontFamilySubClassStencil': 'Трафарет',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Автоматический размер шрифта',
	'responsiveCoachmarkContents': 'Размер шрифта будет отрегулирован автоматически, так чтобы текст уместился при изменении размера текста данного типа. Можно задать размер шрифта в свойствах текста.',

	'propText': 'Сведения о тексте', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Свойства текста', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Размер шрифта',
	'textFontFamily': 'Семейство шрифтов',
	'textFontWeight': 'Насыщенность шрифта', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Ссылка на изображение',
	'propMissingURL': 'Введите URL',
	'propImgTop': 'Свойства изображения', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Общие свойства', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Общие', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Общие', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Цвет заливки', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Цвет текста', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Цвет рамки',
	'propMaintainAxisScales': 'Управление масштабом оси',
	'propShowItemLabel': 'Показать метку элемента',
	'propHideLegend': 'Скрыть легенду',
	'propColorPalette': 'Палитра',
	'propLegendPosition': 'Положение легенды',
	'propHideAxisTitleLabels': 'Скрыть заголовки осей',
	'propLineColor': 'Цвет линии',
	'propBubbleColor': 'Цвет пузырька',
	'propInterpolation': 'Плавные линии',
	'propElementColor': 'Цвет элемента визуализации',
	'propSymbolShape': 'Форма символа',
	'propHeatScalePalette': 'Порядок цветов',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Более темные цвета соответствуют меньшим значениям.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Более темные цвета соответствуют большим значениям.',
	'propImageDetails': 'Сведения об изображении', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Сведения о веб-странице', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Сведения о носителе', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Введите URL и нажмите клавишу Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Положение и стиль',
	'propPositionLabel': 'Положение', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Размер', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Ширина',
	'propResizeHeight': 'Высота',
	'propRotateLabel': 'Повернуть',
	'propRotateAngle': 'Угол', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Количество значков',
	'propScaleDescription': 'Выберите количество значков',
	'propScaleFew': 'Низкий',
	'propScaleDefault': 'По умолчанию',
	'propScaleMany': 'Высокий',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Это значение должно быть числом',

	'mediaAriaLabel': 'Ввод url',
	'dropdownAriaLabel' : 'Выпадающий список',
	'ariaGroupLabel': 'Категория выпадающего списка: элемент %{cateoryLabel}: %{itemLabel}. Чтобы развернуть его, нажмите клавишу ВНИЗ. Чтобы перейти к другому элементу, нажмите клавишу ВВЕРХ и ВНИЗ, либо нажмите клавишу ESCAPE, чтобы свернуть.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Последнее обновление: %{timeInterval} тому назад',
	'widgetTimer': 'Таймер виджета',

	// Theme colors
	'transparent': 'Нет цвета',
	'white': 'Белый',
	'lightGrey': 'Светло-серый',
	'grey': 'Серый',
	'darkGrey': 'Темно-серый',
	'black': 'Черный',
	'lightBlue': 'Голубой',
	'blue': 'Синий',
	'darkBlue': 'Темно-синий',
	'yellow': 'Желтый',
	'orange': 'Оранжевый',
	'lime': 'Травяной',
	'green': 'Зеленый',
	'peach': 'Персиковый',
	'red': 'Красный',
	'violet': 'Фиолетовый',
	'aqua': 'Голубой',
	'purple': 'Лиловый',
	'plum': 'Сливовый',
	'gray10': 'Серый 10',
	'gray20': 'Серый 20',
	'gray30': 'Серый 30',
	'gray50': 'Серый 50',
	'gray60': 'Серый 60',
	'gray70': 'Серый 70',
	'gray80': 'Серый 80',
	'gray90': 'Серый 90',
	'gray100': 'Серый 100',
	'blue50': 'Синий 50',
	'blue60': 'Синий 60',
	'blue70': 'Синий 70',
	'green40': 'Зеленый 40',
	'green50': 'Зеленый 50',
	'red50': 'Красный 50',
	'red60': 'Красный 60',


	//Theme Palette Label
	'paletteLabel': 'Палитра IBM %{number}',
	'heatPaletteLabel': 'Тепловая палитра IBM %{number}',
	'conditionalPaletteLabel': 'Условная палитра IBM %{number}',
	'carbonPaletteXLight': 'Светлая Carbon X',
	'carbonPaletteXDark': 'Темная Carbon X',
	'carbonPalettePurple': 'Пурпурный',
	'carbonPaletteTeal': 'Сине-зеленый',
	'carbonPaletteCyan': 'Циан',
	'carbonPaletteMagenta': 'Маджента',
	'carbonPalettePurpleTeal': 'Пурпурный Сине-зеленый',
	'carbonPaletteCyanMagenta': 'Циан Маджента',
	'carbonPaletteGreenRed': 'Зеленый Красный',
	'carbonPaletteGreenYellowRed': 'Зеленый Желтый Красный',
	'carbonPalettePurpleTealConvergent': 'Пурпурный Сине-зеленый Конвергентный',
	'carbonPaletteCyanMagentaConvergent': 'Циан Маджента Конвергентный',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Световая палитра IBM',
	'userPaletteColor_defaultTheme': 'Палитра по умолчанию IBM',
	'userPaletteColor_darkTheme': 'Темная палитра IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Цвет фона',
	'propLayoutPositioning': 'Размещение макета',
	'propLayoutRelative': 'Относительный',
	'propLayoutAbsolute': 'Абсолютная величина',
	'propLayoutPositioningCoachmarkTitle': 'Выбрать стиль макета',
	'propLayoutPositioningCoachmarkContent': 'При относительном макете размер и положение виджетов подстраиваются, чтобы вписаться в экран. Виджеты в абсолютном макете появляются точно с тем размером и расположением в представлении, какие вы задали для них, независимо от размера экрана.',
	'gridText': 'Показать сетку',
	'snapText': 'Привязать к сетке',
	'snapObjectsText': 'Привязать к объектам',
	'fitPageText': 'Уместить на странице',
	'gridLabel': 'Таблица',
	'heightUnit': 'ч',
	'widthUnit': 'w',
	'pixelUnit': 'пл',
	'propPageSizeLabel': 'Размеры страницы',
	'propPageSizePresetAriaLabel': 'Предварительно заданный размер страницы',
	'propPageSizePreset': 'Предварительно заданный',
	'propPageSizePresetCustom': 'Настроить',
	'propPageSizePreset16x9': 'Экран 16:9',
	'propPageSizePreset4x3': 'Экран 4:3',
	'propPageSizePresetInfographic': 'Инфографика',
	'propPageSizeWidth': 'Ширина',
	'propPageSizeHeight': 'Высота',
	'propPageSizeWidthAriaLabel': 'Ширина страницы',
	'propPageSizeHeightAriaLabel': 'Высота страницы',
	'propPageSizeAdjustedMessage': 'Размер страницы был увеличен, так как ваша запись была меньше минимальной или не умещалась в сводной панели.',
	'propTabShow': 'Показать вкладки',
	'propShowTabsInPreview': 'Показать вкладки в предварительном просмотре',
	'multilingualDashboardsLabel': 'Языки',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- По умолчанию',
	'multilingualDashboardsAddLinkText': 'Добавить другой язык',
	'multilingualDashboardsSelect': 'Выбрать',
	'multilingualDashboardsButtonLabel': 'Добавить',
	'multilingualDashboardTranslationMode': 'Теперь вы в режиме перевода (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Готово',
	'multilingualDashboardRemainingStrings': 'Число оставшихся переводов: %{numTranslationsLeft}',
	'multilingualDashboardRemainingString': 'Остался 1 перевод',
	'multilingualDashboardsSetDefault': 'Задать язык по умолчанию',
	'multilingualDashboardIconMore': 'Дополнительные действия для языка %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Переводимая область',
	'multilingualDeleteTitle': 'Удалить язык',
	'multilingualDeleteLanguageWarning': 'Вы уверены, что хотите удалить язык \'%{language}\'?',
	'multilingualSelectLanguage': 'Выбрать язык',
	'confirmLayoutStyleUpgradeTitle': 'Применить ко всем вкладкам',
	'confirmLayoutStyleUpgrade': 'Применить этот стиль макета ко всем вкладкам в вашей сводной панели?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Удалить',
	'tabDeleteDialogTitle': 'Удалить эту вкладку?',
	'tabDeleteDialogMessage': 'Все содержимое на этой вкладке также будет удалено.',

	// Vis widget
	'propVisTypeReturn': 'Типы визуализации',
	'propVisDetails': 'Сведения',

	// Alignment picker
	'propAlignPickTop': 'Выровнять по верхнему краю',
	'propAlignPickRight': 'Выровнять по правому краю',
	'propAlignPickBottom': 'Выровнять по нижнему краю',
	'propAlignPickLeft': 'Выровнять по левому краю',
	'propAlignPickCenter': 'Выровнять по центру',
	'propAlignPicker': 'Выравнивание',

	// Toolbar picker
	'propToolbarPickBold': 'Полужирный',
	'propToolbarPickUnderline': 'Подчеркивание',
	'propToolbarPickItalic': 'Курсив',
	'propToolbarPickJustifyLeft': 'Выровнять по левому краю',
	'propToolbarPickJustifyCenter': 'Выровнять по центру',
	'propToolbarPickJustifyRight': 'Выровнять по правому краю',
	'propToolbarPickJustify': 'Выровнять по ширине',

	'propList': 'Список',
	'propOrderedList': 'Упорядоченный список',
	'propUnorderedList': 'Неупорядоченный список',

	// Symbol shapes
	'propCircle': 'Круг',
	'propTriangle': 'Треугольник',
	'propSquare': 'Квадрат',
	'propRect': 'Прямоугольник',
	'propStar': 'Звезда',
	'propCross': 'Крестик',
	'propPlus': 'Плюс',
	'propPoly': 'Многоугольник',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Слева',
	'propRight': 'Справа',
	'propTop': 'Вверху',
	'propBottom': 'Внизу',

	// Interpolation options
	'propSmooth': 'Плавная',
	'propStraight': 'Прямолинейный',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Список', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Переместить влево', // screen reader
	'srWidgetMoveUp': 'Переместить вверх', // screen reader
	'srWidgetMoveRight': 'Переместить вправо', // screen reader
	'srWidgetMoveDown': 'Переместить вниз', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Увеличить размер пропорционально', // screen reader
	'srWidgetResizeSmaller': 'Уменьшить размер пропорционально', // screen reader
	'srWidgetResizeBiggerV': 'Увеличить размер по вертикали', // screen reader
	'srWidgetResizeSmallerV': 'Уменьшить размер по вертикали', // screen reader
	'srWidgetResizeBiggerH': 'Увеличить размер по горизонтали', // screen reader
	'srWidgetResizeSmallerH': 'Уменьшить размер по горизонтали', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Повернуть по часовой стрелке', // screen reader
	'srWidgetRotateCCW': 'Повернуть против часовой стрелки', // screen reader

	// Recommended types
	'visChange': 'Изменить визуализацию',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Визуализация',
	'chartLabel': 'Диаграмма %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Чтобы перемещаться по виджету, нажмите F12',
	'f10KeyDescription': 'Нажмите F10, чтобы запустить представление фокуса виджета',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} со значением %{value}',

	'shapeColorLabel': 'Цвет формы',
	'showLegendLabel': 'Показать легенду',

	//Webpage
	'webpageWidgetTitle': 'Виджет веб-страницы',
	'webpagePasteLink': 'Вставьте URL и нажмите Enter, чтобы его сохранить.',
	'propWebpageLink': 'URL веб-страницы',
	'propWebpageTitle': 'Заголовок веб-страницы',
	'propWebpageTitleDescription': 'Заголовок веб-страницы',
	'webpageUrl': 'URL веб-страницы',
	'noWebpageSelected': 'Веб-страница не выбрана',
	'enterWebpageUrl': 'Введите здесь URL веб-страницы',
	'propWebpageTop': 'Свойства веб-страницы', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Отсутствует URL веб-страницы.',
	'webpageUrlValidationError': 'Недопустимый URL веб-страницы.',
	'webpageHttpValidationError': 'Доступ к веб-странице должен осуществляться с использованием ссылки HTTPS.',
	'webpageInvalidDomainError': 'Этот URL веб-страницы указывает на домен, не одобренный администратором. Домены, одобренные вашим администратором: "%{domains}".',

	//VizState
	'vzErrorLoading': 'Не удается загрузить визуализацию',
	'vzErrorLoadingMissingData': 'Не удалось загрузить визуализацию, отсутствуют данные контекста',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Виджет носителя',
	'mediaPasteLink': 'Вставьте URL и нажмите Enter, чтобы его сохранить.',
	'mediaUrl': 'URL носителя',
	'noMediaSelected': 'Носитель не выбран',
	'enterMediaUrl': 'Введите здесь URL носителя',
	'videoHeight': 'Высота:',
	'videoWidth': 'Ширина:',
	'propMediaLink': 'Ссылка на мультимедиа',
	'propMediaTitle': 'Заголовок носителя',
	'propMediaTitleDescription': 'Заголовок носителя',
	'propMediaTop': 'Свойства носителя', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Отсутствует URL ссылки на носитель.',
	'mediaUrlValidationError': 'Недопустимый URL файла носителя.',
	'mediaUnknownValidationError': 'Этот тип носителя не поддерживается.',
	'mediaHttpValidationError': 'Доступ к файлу носителя должен осуществляться с использованием ссылки HTTPS.',
	'mediaInvalidDomainError': 'Этот URL мультимедиа указывает на домен, не одобренный администратором. Домены, одобренные вашим администратором: "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Свойства', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Набор данных',
	'dataViewsLabel': 'Показать',
	'columnQuality': 'Качество данных',
	'columnProperties': 'Свойства данных',

	'dataQuality': 'Качество данных',
	'dataQualityRowCount': 'Число строк',
	'dataQualityDistribution': 'Распределение',
	'dataRowLabel': 'Данные',

	// Modelling UI
	'typeColumn': 'Ввести',
	'modellingColumnType': 'Ввести',
	'modellingColumnAggregation': 'Агрегация',
	'modellingColumnUsage': 'Использование',
	'modellingColumnSort': 'Сортировать',
	'modellingColumnFormat': 'Формат',
	'modellingColumnCategory': 'Категория',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Загрузка...',

	'modellingProcessing': 'Обработка...',
	'modellingImport': 'Импорт',
	'modellingReimport': 'Повторный импорт',
	'modellingDatasourceTitle': 'Источник данных',
	'modellingImportStartedTitle': 'Импорт запущен',
	'modellingImportStartedText': 'Импорт ваших данных может занять некоторое время.\n(Пока данные импортируются, вы можете создать представление.)',
	'importDatasourceTitle': 'Соединения',
	'dropHere': 'Перетащите сюда, чтобы создать новый источник данных...',
	'browseButton': 'Обзор',
	'errorNoData': 'Нет данных для обработки.',
	'errorNoFile': 'Нет файла для закачки.',
	'errorUploadFailed': 'Не удается закачать.',
	'uploadSucceessful': 'Закачка выполнена успешно',
	'del_datasourceTitle': 'Удалить набор данных',
	'del_datasourceMsg': 'Вы уверены, что хотите удалить \'%{name}\'?',
	'modellingFileUpdate': 'Обновить',
	'modellingFileUpdateTitle': 'Обновить набор данных',
	'modellingFileUpdateDescription': 'Хотите обновить \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Обновляется \'%{name}\'',
	'modellingUpdateStartedTitle': 'Импорт обновления запущен',
	'modellingUpdateStartedText': 'Обновление ваших данных может занять некоторое время.\n(Пока данные обновляются, вы можете создать представление.)',
	'modellingErrorImportUploadNoFile': 'Нет файла для закачки.',
	'modellingErrorImportUploadFailed': 'Не удается закачать.',
	'modellingErrorImportUploadInvalidType': 'Тип файла - недопустимый.',
	'modellingErrorImportUploadTableFailed': 'Не удается получить таблицы.',
	'modellingIntentResultsTitle': 'Выберите предложенный набор данных, чтобы его использовать',
	'modellingColumnViewRelationships': 'Просмотр связанных таблиц',
	'modellingTableRelatedTables': 'Таблицы, связанные с \'%{name}\'',
	'modellingTable': '%{name} - Таблица',
	'modellingColumnIncludedInDataSet': 'Добавлено',
	'modellingDataSet': 'Набор данных',
	'modellingViewInDataSet': 'Представление в наборе данных',
	'modellingViewRelatedTables': 'Связанное представление',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Не найдено никаких связанных таблиц',

	'modellingValidatingDataset': 'Проверка...',
	'datasetFinishedRefreshing': 'Набор данных %{datasetName} обновлен.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Разрешить путь объединения:',
	'modellingJoinColumns': 'Задать путь объединения для таблицы: %{name}',
	'modellingJoinToTable': 'Объединить в таблицу: %{name}',

	// Data Quality
	'excluded': 'Исключено',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Фильтр',
	'modellingColumnSortNone': 'Очистить сортировку',
	'modellingColumnSortAsc': 'Сортировка по восходящей',
	'modellingColumnSortDesc': 'Сортировка по нисходящей',
	'modellingColumnRemove': 'Удалить этот столбец',

	// Import File Browser
	'dropboxPageTitle': 'Новое соединение Dropbox',
	'sizeColumn': 'Размер',

	//Modelling Column Property Values
	'dataType_string': 'Строка',
	'dataType_date': 'Дата',
	'dataType_integer': 'Целочисленное',
	'dataType_double': 'Двойная',
	'dataType_float': 'С плавающей запятой',
	'dataType_boolean': 'Логический',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Число',
	'defaultAggregation_countdistinct': 'Подсчет уникальных',
	'defaultAggregation_max': 'Максимум',
	'defaultAggregation_min': 'Минимум',
	'defaultAggregation_avg': 'Среднее',
	'defaultAggregation_sum': 'Сумма',
	'defaultAggregation_auto': 'Авто (%{aggregationType})',

	'type_fact': 'Факт',
	'type_attribute': 'Атрибут',

	'defaultSort_none': 'Не сортировать',
	'defaultSort_asc': 'Сортировка по восходящей',
	'defaultSort_desc': 'Сортировка по нисходящей',

	'category_none': 'Нет',
	'category_location': 'Расположение',
	'category_monetary': 'Денежный',
	'category_time': 'Время',

	// Root menu
	'rootMenuTitle': 'Главное меню',

	'errorMessageTitle': 'Ошибка',
	'errorMessageDetails': 'Сведения: ',
	'errorMessageTitleAssetAlreadyExists': 'Актив уже существует',

	'defaultTabTitle': 'Вкладка %{index}',
	'tabAddBtnTitle': 'Добавить новую вкладку',

	'unsupportedConditionalFormattingEncountered': 'Условное форматирование больше не применяется к некоторым столбцам.',


	// Homepage View
	'nameColumn': 'Имя',
	'creatorColumn': 'Кем создан',
	'creationDateColumn': 'Дата создания',
	'versionColumn': 'Версия',
	'modifiedColumn': 'Последнее изменение',

	'filterBy': 'Применить фильтр к элементам',
	'allFilter': 'Все элементы',
	'createdByMeFilter': 'Создано мною',
	'sharedWithMeFilter': 'Используется совместно со мною',
	'favoritesFilter': 'Мое избранное',
	'recentsFilter': 'Недавно добавленные',
	'sortBy': 'Сортировать по',

	// Sort Menu
	'sortModified': 'Изменено',
	'sortUpdated': 'Обновлено',
	'sortName': 'Имя',

	'viewAs': 'Просмотр в виде',
	'thumbnailsView': 'Просмотр в виде миниизображений',
	'listView': 'Просмотр в виде списка',
	'createMenu': 'Создать',
	'newAppItem': 'Сводная панель',
	'newDataSet': 'Набор данных',

	'menuSelectionState_a11y': 'Для селектора "%{item}" задано значение "%{selectedItem}"',

	'unableToShareItem': 'Не удается совместно использовать элемент "%{item}".',
	'toastFetchingContent': 'Получение дополнительного содержимого...',
	'unableToGetData': 'Не удается получить содержимое.',
	'unableToFavorite': 'Не удается изменить состояние избранного.',
	'hpErrorMissingRequiredOptions': 'Отсутствуют необходимые опции инициализации',
	'unableToOpenBoard': 'Не удается открыть "%{name}".',
	'unableToDuplicateBoard': 'Не удается дублировать "%{name}".',
	'unableToCreateBoard': 'Не удается создать "%{name}".',
	'unableToCreateBoardNameConflict': 'Уже существует актив с таким же именем.',

	// DataSet Detail View
	'status': 'Состояние',
	'numberOfRows': 'Строки',
	'importWarnings': 'Предупреждения',
	'lineNumbers': 'Линии',
	'excerptFromSource': 'Выдержка',
	'reason': 'Причина',
	'numberOfRowsDropped': 'строк(а/и) отброшены',
	'oneRowDropped': '1 строка отброшена',

	// Type Menu
	'typeMenuLabel': 'Ввести',
	'dashboardsLabel': 'Cводные панели',
	'datasetsLabel': 'Наборы данных',
	'storiesLabel': 'Истории',
	'allLabel': 'Все типы',

	// Board Page View App Bar
	'datasets': 'Наборы данных',
	'settings': 'Свойства',
	'add': 'Добавить',
	'widgets': 'Виджеты',
	'dashboardProperties': 'Свойства cводной панели',
	'searchPanel' : 'Поиск',
	'pins': 'Собрание',
	'pinsOld': 'Мои булавки',
	'pinsDateFilterHeading' : 'Дата закрепления',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} булавка |||| %{smart_count} булавки',
	'pinSearch': 'Поиск',
	'pinSearchOld': 'Поиск булавок',
	'pinListView': 'Представление списка',
	'pinIconView': 'Представление значков',
	'pinRemove': 'Удалить',
	'pinCreate': 'Создать',
	'pinDeleteError': 'Мы не можем удалить из собрания один или несколько активов. Повторите попытку позже.',
	'pinDeleteErrorOld': 'Мы не можем удалить одну или несколько булавок. Повторите попытку позже.',
	'pinRetrieveError': 'Мы не можем получить одну или несколько булавок. Повторите попытку позже.',
	'NoPinsCollected': 'Без визуализаций с булавками',
	'pinDeletedToast': 'Булавка удалена',
	'pinAddedToast': 'Булавка успешно добавлена в панель Мои булавки',
	'pinningToast': 'Обработка булавки...',
	'pinDateFilter': 'Фильтр дат',
	'pinDateFilterAll': 'Все',
	'pinDateFilterToday': 'Сегодня',
	'pinDateFilterYesterday': 'Вчера',
	'pinDateFilterPastWeek': 'Прошлая неделя',
	'pinDateFilterPastMonth': 'Прошлый месяц',
	'pinDateFilterEarlier': 'Раньше',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Изменить заголовок',
	'toolbarActionSort': 'Сортировать',
	'toolbarActionSortAscending': 'Сортировка по восходящей',
	'toolbarActionSortDescending': 'Сортировка по нисходящей',
	'toolbarActionSortAuto': 'Авто (%{sortOrder})',
	'toolbarActionFormat': 'Данные формата',
	'toolbarActionFormatAbbreviation': 'Сокращать',
	'toolbarActionFormatNone': 'Автоматически',
	'toolbarActionFilter': 'Фильтр',
	'toolbarActionTopBottom': 'Первые или последние',
	'toolbarActionAddShape': 'Добавить форму',
	'toolbarActionRmvShape': 'Удалить форму',
	'toolbarActionToggleShapeDrop': 'Инфографическая форма',
	'toolbarActionToggleShapeDropTitle': 'Создать инфографику',
	'toolbarActionToggleShapeDropText': 'Перетащите в это поле форму, чтобы создать инфографику.',
	'toolbarActionAggregationType': 'Суммировать',
	'toolbarDeleteActionText': 'Удалить столбец',
	'toolbarActionFilterLocalKeepSelected': 'Оставить',
	'toolbarActionFilterLocalExcludeSelected': 'Исключить',
	'toolbarActionFilterAllKeepSelected': 'Фильтр',
	'toolbarActionSimpleCalculation': 'Простое вычисление',
	'toolbarActionDrillBack': 'Назад',
	'toolbarActionDrillUp': 'Свернуть',
	'toolbarActionDrillDown': 'Детализировать данные',
	'toolbarActionNavigate': 'Обзор',
	'toolbarActionCreateFilterGroup': 'Создать новое соединение',
	'toolbarActionDisconnectFilterGroup': 'Разорвать все ссылки',
	'toolbarActionLinkFilterGroup': 'Добавить к существующему соединению',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Добавить',
	'sidebarMultiselect': 'Переключить выбор нескольких',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} выбрано',

	'multiselectWithTotalMsg': '%{count} из %{total}',
	'sidebarGoBack': 'Перейти назад',

	//DataSet pane
	'errorLoadingDataSets': 'Мы не можем загрузить этот набор данных',
	'errorLoadingDataSetMetaData': 'Мы не можем загрузить этот набор данных',
	'dataSetPaneLastUpdated': 'Последнее обновление: %{date}',
	'dataSetPaneDateUnknown': 'Неизвестно',
	'sourcePaneLabel': 'Выбранные источники',
	'addSourceLabel': 'Добавить источник',
	'find_label': 'Найти',
	'navigationPathsLabel': 'Пути навигации',

	//widgetlist
	'errorLoadingWidgetList': 'Мы не можем загрузить объекты.',
	'errorLoadingThemeFile': 'Мы не можем загрузить определение темы',
	'errorLoadingLayoutFile': 'Мы не можем загрузить представление.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Мы не можем загрузить доступные определения визуализации',

	'dwErrorLoadingVisualizationNotFound': 'Мы не можем загрузить объект, та как у него отсутствует определение визуализации',
	'dwErrorLoadingVisualizationListNotFound': 'Мы не можем загрузить визуализацию.',
	'dwErrorRunningQuery': 'Мы не можем получить данные из набора данных %{datasetName}.',
	'dwErrorGeoData': 'У нас возникли затруднения при выводе географических данных на карте. Выберите другой тип визуализации. ',
	'dwPromptSignonCancelWarning': 'Данные для этой визуализации недоступны. Введите правильные учетные данные.',
	'dwErrorMissingDataset': 'Мы не можем загрузить визуализацию, так как связанный набор данных \'%{datasetName}\' недоступен.',
	'dwErrorRenderingVisualization': 'Мы не можем загрузить эту визуализацию.',
	'dwErrorVisualizationTooSmall': 'Визуализация слишком мала, чтобы показать содержащиеся в ней данные. Сделайте визуализацию больше или ограничьте содержащиеся в ней данные.',
	'aria_label_datatable': 'Таблица данных',
	'aria_key_navi_datatable_desc': 'Используйте клавиши со стрелками для перемещения в каждую ячейку. Чтобы перейти к первой строке, нажмите клавиши Control и Home, чтобы перейти к последней строке, нажмите клавиши Control и End.',
	'geomapUnrecognizedLocations': 'Нераспознанные положения:',
	'geomapAmbiguousLocations': 'Неоднозначные регионы:',

	// custom widget
	'customWidget': 'Пользовательский виджет',
	'customWidgetsTitle': 'Пользовательские виджеты',
	'noCustomWidgets': 'Нет пользовательских виджетов',

	// Action names
	'toggleContextBar': 'Переключить панель контекста',
	'delete': 'Удалить',
	'share': 'Совместно',
	'unshare': 'Отменить совместное',
	'rename': 'Переименовать',
	'close': 'Закрыть',
	'duplicate': 'Дублировать',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Повторить',

	'changeTemplate': 'Изменить шаблон',

	// Aggregation Types
	'sum': 'Сумма',
	'count': 'Число',
	'countdistinct': 'Подсчет уникальных',
	'avg': 'Среднее',
	'min': 'Минимум',
	'max': 'Максимум',
	'custom': 'Настроить',
	'calculated': 'Вычисленный',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% изменений',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Критерии визуализации...',
	'QuickAddResultsHeader': 'Визуализации данных',
	'NoQuickAddResults': 'Тому, что вам нужно, ничего не соответствует. Создать новый набор данных?',
	'NoQuickAddResultsRetry': 'Мы не можем найти никаких соответствий. Попробуйте еще раз, используя другие термины.',
	'templateWidgetTitle': 'Шаблон',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(пустой)',

	'nullValueContent': '(нет значения)',
	'nullValueText': 'Пустое значение',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Текстовый фильтр - %{columnName}',

	'textFilterSelectTab': 'Выбрать',

	'textFilterConditionTab': 'Задать условие',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Нет доступных элементов.',

	'textFilterEquals': 'Равно',
	'textFilterContains': 'Содержит',
	'textFilterBeginsWith': 'Начинается с',
	'textFilterEndsWith': 'Заканчивается на',
	'textFilterDoesNotEqual': 'Не равно',
	'textFilterDoesNotContain': 'Не содержит',
	'textFilterDoesNotBeginWith': 'Не начинается с',
	'textFilterDoesNotEndWith': 'Не заканчивается на',
	'textFilterSampleText': 'Например: A',

	'textFilterAndButton': 'И',
	'textFilterOrButton': 'Или',

	'dateFilterMessage': 'Выбрать диапазон дат',
	'dateRangeControlRegionLabel': 'Фильтр диапазона дат - %{columnName}',
	'dateFilterRangeOption': 'Опция диапазона',
	'dateFilterDateLabel': 'Дата',
	'dateFilterBlank': '(пустой)',
	'dateFilterBefore': 'Перед',
	'dateFilterAfter': 'После',
	'dateFilterBetween': 'Между',
	'dateFilterSampleText': 'ГГГГ-ММ-ДД',
	'dateTitle': 'Дата',
	'dateIncludeBlankLabel': 'Включить пустую дату',

	'timeTitle': 'Время',
	'timeFilterMessage': 'Выбрать диапазон времени',
	'dateTimeFilterMessage': 'Выбрать диапазон дат и времени',

	'topbottomNumberOfResultsLabel': 'Число результатов',
	'topbottomPercentLabel': 'Процент',
	'topbottomNumberOfResultsLimit': 'Между %{lower}-%{higher}',
	'topbottomSelectOption': 'Опция Первые или последние',
	'topbottomOptionLabel': 'Показать',
	'searchByLabel': 'На основе',
	'searchNoMatches': 'Совпадения не найдены',
	'topbottomRankColumnLabel': 'Добавить в таблицу столбец ранга',
	'topbottomNone': 'Нет',
	'topCount': 'Число первых',
	'topPercent': 'Первые %',
	'bottomCount': 'Число последних',
	'bottomPercent': 'Последние %',
	'topbottomSearchColumn': 'Найти столбец',
	'searchColumnAriaLabel': 'Найдите столбец. Введите имя столбца, который нужно искать, а затем используйте стрелку вниз, чтобы найти столбец в списке',
	'rankColumnLabel': 'Ранг (%{columnLabel})',
	'topbottomClearLabel': 'Очистить',

	'rangeFilterControlRegionLabel': 'Фильтр диапазона - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Элемент управления ползунком; чтобы переместить хэндлы ползунка, используйте стрелки вправо и влево',
	'sliderHandleLabel': 'Хэндл ползунка',
	'a11ySliderHandleLabel': 'Ручка ползунка %{sliderValue}',
	'sliderInputLabel': 'значение',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Некоторые элементы набора данных, используемые в этой визуализации, недоступны.',
	'datasetItemUnavailable': 'Этот элемент набора данных недоступен.',

	//Authoring topBottom
	'topOperator': 'Вверху',
	'bottomOperator': 'Внизу',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} по %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Только этот объект',
	'deleteTopBottom': 'Удалить число первых или последних',
	'editTopBottom': 'Изменить число первых или последних',
	'deleteDrillState': 'Удалить текущее состояние детализации',
	'ariaDeleteDrillStateLabel': 'Чтобы изменить число первых или последних, нажмите клавишу ENTER.',
	'drillUpStateTitle': 'Свернуть детализированные данные',
	'drillDownStateTitle': 'Раскрыть детализированные данные',
	'ariaEditTopBottomLabel': 'Чтобы изменить число первых или последних, нажмите клавишу ENTER.',
	'ariaDeleteTopBottomLabel': 'Чтобы удалить число первых или последних, нажмите клавишу DELETE.',

	// Authoring filtering
	'dimFilterIn': 'Включает: %{in}',
	'dimFilterNotIn': 'Исключает: %{out}',
	'measureFilterBetween': 'Между %{lowerBound} и %{upperBound}',
	'measureFilterNotBetween': 'Не между %{lowerBound} и %{upperBound}',
	'gtFilter': 'После %{lowerBound}',
	'ltFilter': 'До %{upperBound}',
	'notGtFilter': 'Не после %{lowerBound}',
	'notLtFilter': 'Не раньше %{upperBound}',
	'localFilterTitle': 'Только этот объект',
	'globalFilterTitle': 'Все объекты',
	'deleteFilter': 'Удалить фильтр',
	'editFilter': 'Изменить фильтр',
	'ariaEditFilterLabel': 'Чтобы изменить фильтр, нажмите клавишу ENTER.',
	'ariaDeleteFilterLabel': 'Чтобы удалить фильтр, нажмите клавишу DELETE.',

	// Prompts
	'ariaEditPrompt': 'Чтобы изменить значение приглашения, нажмите клавишу ENTER',

	'moreDataIndicator': 'Ваши данные обрезаны на уровне %{threshold} элементов. Примените фильтр, чтобы показать меньше данных.',

	// data point filtering
	'dataPointFilterTitle': 'Точки данных',
	'dataPointFilterIncludeSummary': 'Включены точки данных: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Исключены точки данных: %{valueCount}',

	// DB2 connection page
	'db2Database': 'DB2 Database (%{jdbcConnection})',
	'db2Title': 'Соединиться с IBM DB2',

	// Database
	'databaseConnectionMessage': 'Введите сведения о соединении с базой данных:',
	'connectionString': 'Строка соединения с базой данных',
	'databaseCredentials': 'Учетные данные: ',
	'databaseUserName': 'Имя пользователя',
	'databasePassword': 'Пароль',
	'databaseConnect': 'Соединиться',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Введите термин для поиска:',
	'twitterKeyword': 'Ключевое слово',
	'twitterSearch': 'Поиск',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Невозможно создать представление: %{error}\nНеудачная операция: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Фильтры виджета',
	'missingColumn': 'Отсутствует: %{columnLabel}',
	'missingFiltering': 'Отсутствуют фильтры для следующих ID столбцов:',
	'heatByLabel': 'Тепло по',
	'evColumns': 'Столбцы',
	'evLocalFilters': 'Локальные фильтры',
	'evExpand': 'Развернуть',
	'evFilterTooltip': 'Фильтр',
	'evAdd': 'Добавить столбец',

	// Navigation View
	'navigationBack': 'Назад',

	// Pinning
	'contentPinFail': 'Мы не можем собрать содержимое. Повторите попытку позже.',
	'contentPinFailOld': 'Мы не можем отметить содержимое булавками. Повторите попытку позже.',

	// Layouts
	'dropZoneLabel': 'Перетащите сюда, чтобы развернуть до максимума',

	//Share
	'shareDefaultPageTitle': 'Страница %{index}',

	'nextPage': 'Следующая страница',
	'previousPage': 'Предыдущая страница',

	'assetAssembly': 'представление',

	'toolbar_save': 'Сохранить',
	'brgr_saveAs': 'Сохранить как',
	'brgr_refresh': 'Обновить',

	// Save
	'saving': 'Выполняется сохранение...',
	'save_success': 'Ваше представление сохранено.',
	'save_failure': 'Извините. Сохранить ваше представление не удалось. Повторите попытку позже.',
	'dashboard_save_success': 'Ваша сводная панель сохранена.',

	'geminiLeave': 'Вы собираетесь закрыть IBM Watson Analytics.',

	'warning': 'Предупреждение',
	'missingDataSetData': 'Данные для этого набора данных недоступны. Обновите набор данных или обратитесь к своему администратору, чтобы получить доступ к источнику.',

	// Calculations
	'error_calculation_in_use': 'Выбранное вычисление используется, и удалить его нельзя.',

	'resize': 'Изменить размер',
	'rotate': 'Повернуть',
	'moveHandle': 'Переместить виджет',
	'expandHandle': 'Развернуть',
	'panHandle': 'Панорамирование',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Перейти к',

	// Slide out titles
	'shapeSlideoutTitle': 'Формы',
	'textSlideoutTitle': 'Текстовый',
	'mediaSlideoutTitle': 'Носитель',
	'visualizationSlideoutTitle': 'Визуализации',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Предоставленная JSON недопустима. Дополнительную информацию смотрите в журнале ошибок.',

	// Widget type labels
	'shape_label': 'Форма',
	'image_label': 'Изображение',
	'data_label': 'Диаграмма',
	'media_label': 'Носитель',
	'text_label': 'Текстовый',
	'embedMedia_label': 'Носитель',
	'youtube_label': 'Видео YouTube',
	'webpage_label': 'Веб-страница',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Форма',
	'noExtraText_shape_numbered': 'Форма (%{number})',
	'few_shape': 'Группа форм %{count}',
	'many_shape': 'Группа форм %{count}',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Изображение %{text}',
	'one_image_numbered': 'Изображение %{text} (%{number})',
	'noExtraText_image': 'Изображение',
	'noExtraText_image_numbered': 'Изображение (%{number})',
	'few_image': 'Группа изображений %{count}',
	'many_image': 'Группа изображений %{count}',
	'noExtraText_text': 'Пустое текстовое поле',
	'noExtraText_text_numbered': 'Пустое текстовое поле (%{number})',
	'few_text': 'Группа текстовых полей %{count}',
	'many_text': 'Группа текстовых полей %{count}',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Просмотр куба',
	'pacubeviewer_named': 'Средство просмотра куба %{name}',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Перекрестная таблица %{values} по %{row_level1} и %{column_level1}',
	'crosstab_opt_mapping_numbered': 'Перекрестная таблица %{values} по %{row_level1} и %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Перекрестная таблица %{values} по %{row_level1}',
	'crosstab_has_mapping_numbered': 'Перекрестная таблица %{values} по %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Пустая перекрестная таблица',
	'crosstab_no_mapping_numbered': 'Пустая перекрестная таблица (%{number})',
	'crosstab_named': 'Перекрестная таблица %{name}',
	'crosstab_named_numbered': 'Перекрестная таблица %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Таблица %{grid_cols}',
	'JQGrid_has_mapping_numbered': 'Таблица %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Пустая таблица',
	'JQGrid_no_mapping_numbered': 'Пустая таблица (%{number})',
	'JQGrid_named': 'Таблица %{name}',
	'JQGrid_named_numbered': 'Таблица %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Иерархия %{level1}',
	'hierarchy_has_mapping_numbered': 'Иерархия %{level1} (%{number})',
	'hierarchy_no_mapping': 'Пустая иерархия',
	'hierarchy_no_mapping_numbered': 'Пустая иерархия (%{number})',
	'hierarchy_named': 'Иерархия %{name}',
	'hierarchy_named_numbered': 'Иерархия %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Карта %{categories}',
	'map_has_mapping_numbered': 'Карта %{categories} (%{number})',
	'map_no_mapping': 'Пустая карта',
	'map_no_mapping_numbered': 'Пустая карта (%{number})',
	'map_named': 'Карта %{name}',
	'map_named_numbered': 'Карта %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Значение сводки %{actual}',
	'summary_has_mapping_numbered': 'Значение сводки %{actual} (%{number})',
	'summary_no_mapping': 'Пустое значение сводки',
	'summary_no_mapping_numbered': 'Пустое сводное значение (%{number})',
	'summary_named': 'Сводное значение %{name}',
	'summary_named_numbered': 'Сводное значение %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'КПЭ %{actual} по %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'КПЭ %{actual} по %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'КПЭ %{actual}',
	'kpi_has_mapping_numbered': 'КПЭ %{actual} (%{number})',
	'kpi_no_mapping': 'Пустой КПЭ',
	'kpi_no_mapping_numbered': 'Пустой КПЭ (%{number})',
	'kpi_named': 'КПЭ %{name}',
	'kpi_named_numbered': 'КПЭ %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Инфографика %{actual}',
	'infographicSummary_has_mapping_numbered': 'Инфографика %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Пустая инфографика',
	'infographicSummary_no_mapping_numbered': 'Пустая инфографика (%{number})',
	'infographicSummary_named': 'Инфографика %{name}',
	'infographicSummary_named_numbered': 'Инфографика %{name} (%{number})',
	'noExtraText_youtube': 'Видео YouTube',
	'noExtraText_youtube_numbered': 'Видеоролик YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Видео YouTube %{text}',
	'one_youtube_numbered': 'Видео YouTube %{text} (%{number})',
	'few_youtube': 'Группа видеороликов YouTube %{count}',
	'many_youtube': 'Группа видеороликов YouTube %{count}',
	'noExtraText_embedMedia': 'Ссылка на мультимедиа',
	'noExtraText_embedMedia_numbered': 'Ссылка на носитель (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Ссылка на носитель %{text}',
	'one_embedMedia_numbered': 'Ссылка на носитель %{text} (%{number})',
	'few_embedMedia': 'Группа ссылок на носители %{count}',
	'many_embedMedia': 'Группа ссылок на носители %{count}',
	'noExtraText_media': 'Носитель',
	'noExtraText_media_numbered': 'Носитель (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Носитель %{text}',
	'one_media_numbered': 'Носитель %{text} (%{number})',
	'few_media': 'Группа носителей %{count}',
	'many_media': 'Группа носителей %{count}',
	'noExtraText_webpage': 'Веб-страница',
	'noExtraText_webpage_numbered': 'Веб-страница (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Веб-страница %{text}',
	'one_webpage_numbered': 'Веб-страница %{text} (%{number})',
	'few_webpage': 'Группа из %{count} веб-страниц',
	'many_webpage': 'Группа из %{count} веб-страниц',
	'one_unknown': 'Объект',
	'one_unknown_numbered': 'Объект (%{number})',
	'few_unknown': 'Группа объектов %{count}',
	'many_unknown': 'Группа объектов %{count}',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Следующая',
	'previous': 'Предыдущее',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Текущая группа навигации - %{navigation_group_name}',

	//Page Context
	'filterBlank': '(пустой)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Не удается загрузить значения фильтра',
	'editTimelineHighlight': 'Изменить выделение',

	'filterDockChevronLeft': 'Прокрутить данные',
	'filterDockChevronRight': 'Прокрутить данные',
	'expand': 'Развернуть',
	'collapse': 'Свернуть',

	//Reset Dashboard
	'dashboardResetTitle': 'Сброс сводной панели',
	'dashboardResetMessage': 'Вы уверены, что хотите произвести сброс всех изменений, примененных к этой сводной панели?',
	'dashboardResetToast': 'Ваша сводная панель сброшена.',

	//Generate PDF
	'buildingPDF': 'Построение PDF...',
	'exportPDF': 'Экспорт в PDF',
	'pageSize': 'Размеры страницы',
	'orientation': 'Ориентация',
	'filtersPresentPDF': 'Фильтры, примененные к визуализуализациям на предыдущей странице:',
	'errorPDF': 'Не удается сгенерировать PDF. Произведите обновление и повторите попытку.',
	'printPDFInfo': 'Просмотр документации',
	'pdfWidget': 'Виджет',
	'includeFilters': 'Показать сведения о фильтре',
	'portrait': 'Книжная',
	'landscape': 'Альбомная',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Ваша сводная панель обновлена. Сохраните данные сейчас, чтобы обеспечить оптимальную производительность.',

	'ariaFullScreenMessage': 'Нажмите клавишу Escape, чтобы выйти из полноэкранного режима',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Упакованная пузырьковая иерархическая диаграмма %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Упакованная пузырьковая иерархическая диаграмма %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Пустая упакованная пузырьковая иерархическая диаграмма',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Пустая упакованная пузырьковая иерархическая диаграмма (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Упакованная пузырьковая иерархическая диаграмма %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Упакованная пузырьковая иерархическая диаграмма %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Диаграмма Маримекко %{categories} на %{values}',
	'LIVE_marimekko_has_mapping_numbered': 'Диаграмма Маримекко %{categories} на %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Пустая диаграмма Маримекко',
	'LIVE_marimekko_no_mapping_numbered': 'Пустая диаграмма Маримекко (%{number})',
	'LIVE_marimekko_named': 'Диаграмма Маримекко %{name}',
	'LIVE_marimekko_numbered': 'Диаграмма Маримекко %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Диаграмма Солнечные лучи %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Диаграмма Солнечные лучи %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Пустая диаграмма Солнечные лучи',
	'LIVE_sunburst_no_mapping_numbered': 'Пустая диаграмма солнечных лучей (%{number})',
	'LIVE_sunburst_named': 'Диаграмма Солнечные лучи %{name}',
	'LIVE_sunburst_named_numbered': 'Диаграмма Солнечные лучи %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Диаграмма анализа драйверов %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Диаграмма анализа драйверов %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Пустая диаграмма Анализ драйверов',
	'LIVE_decision_analysis_no_mapping_numbered': 'Пустая диаграмма анализа драйверов (%{number})',
	'LIVE_decision_analysis_named': 'Диаграмма анализа драйверов %{name}',
	'LIVE_decision_analysis_named_numbered': 'Диаграмма анализа драйверов %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Линейная и вертикальная столбчатая диаграмма %{categories} по %{columnValue} и %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Линейная и вертикальная столбчатая диаграмма %{categories} по %{columnValue} и %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Линейная и вертикальная столбчатая диаграмма %{columnValue} и %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': 'Линейная и вертикальная столбчатая диаграмма %{categories} по %{columnValue} и %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Пустая линейная и вертикальная столбчатая диаграмма',
	'LIVE_line_column_no_mapping_numbered': 'Пустая линейная диаграмма и столбчатая диаграмма (%{number})',
	'LIVE_line_column_named': 'Линейная и вертикальная столбчатая диаграмма %{name}',
	'LIVE_line_column_named_numbered' : 'Линейная и вертикальная столбчатая диаграмма %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Пузырьковая диаграмма %{x} по %{y} и %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Пузырьковая диаграмма %{x} по %{y} и %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Пустая пузырьковая диаграмма',
	'LIVE_bubble_chart_no_mapping_numbered': 'Пустая пузырьковая диаграмма (%{number})',
	'LIVE_bubble_chart_named': 'Пузырьковая диаграмма %{name}',
	'LIVE_bubble_chart_named_numbered': 'Пузырьковая диаграмма %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Диаграмма с маркерами %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Диаграмма с маркерами %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Пустая диаграмма в виде схемы',
	'LIVE_bullet_no_mapping_numbered': 'Пустая диаграмма с маркерами (%{number})',
	'LIVE_bullet_named': 'Диаграмма с маркерами %{name}',
	'LIVE_bullet_named_numbered': 'Диаграмма с маркерами %{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Данные на этой сводной панели предоставлены',
	'showFooterToggleButtonText': 'Показать нижний колонтитул',
	'showFooterSectionText': 'Нижний колонтитул'
});
